import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import * as DataTableConfigDAO from 'notebook/data-tables/DataTableConfigDAO';
import {DataTableConfig, FromServerDataTableConfig} from 'notebook/data-tables/DataTableConstants';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import * as SchemaConfigReduxActions from 'schemas/spec/SchemaConfigReduxActions';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import getSpecError from 'ui-library/spec-editor/getSpecError';

export function fetchAllDataTableConfigs(): void {
  DataTableConfigDAO.fetchAllDataTableConfigs().done(
    ({dataTableConfigs}: DataTableConfigDAO.DataTableConfigsResponse) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.WORKFLOW_ALL_DATA_TABLE_CONFIGS_FETCH_COMPLETED,
        dataTableConfigs,
      });
    }
  );
}

export function publish(
  dataTableConfigToPublish: DataTableConfig,
  {
    columnTypesByCid,
    fieldIdsToDelete,
    onSuccess,
    onError,
  }: {
    columnTypesByCid?: {[cid: string]: string};
    fieldIdsToDelete?: Array<number>;
    onSuccess?: (dataTableConfig: FromServerDataTableConfig) => void;
    onError?: (args: {errors: Array<string>; message: string}) => void;
  } = {}
): void {
  LoadingScreen.show('Publishing...');
  DataTableConfigDAO.publish(dataTableConfigToPublish, {
    columnTypesByCid,
    fieldIdsToDelete,
  })
    .done(({dataTableConfig, schemaSpec}: DataTableConfigDAO.PublishDataTableConfigResponse) => {
      const {assaySchema} = dataTableConfig;
      AppDispatcher.dispatch({
        actionType: EventConstants.ASSAY_SCHEMA_FETCHED,
        assaySchema,
      });
      getStore().dispatch(SchemaConfigReduxActions.schemaSpecFetched(assaySchema.id, schemaSpec));
      notifications.success('Updated schema successfully');
      if (onSuccess) {
        onSuccess(dataTableConfig);
      }
    })
    .fail((response) => {
      const specError = getSpecError(response);
      if (onError && specError) {
        const {errors, errorMessage} = specError;
        onError({errors, message: errorMessage});
      } else {
        notifications.notifyError(response);
      }
    })
    .always(() => {
      LoadingScreen.hide();
    });
}
